<template>
    <div class="vue-high-contrast-switch contrast-switch-wrapper">
        <div class="contrast-switch custom-control custom-switch">
            <label :class="highContrast ? 'checkbox-checked' : 'checkbox-unchecked'" class="custom-control-label">
                {{ highContrastText }}

                <input
                    @change="handleChange"
                    v-model="highContrast"
                    type="checkbox"
                    class="custom-control-input"
                >
            </label>
        </div>

        <span aria-hidden="true">
            <template v-if="highContrast">
                {{ onText }}
            </template>
            <template v-if="!highContrast">
                {{ offText }}
            </template>
        </span>
    </div>
</template>

<script>
export default {
    name: 'HighContrastSwitch',

    data() {
        return {
            highContrast: false,
            highContrastText: window.Drupal.t('High contrast'),
            onText: window.Drupal.t('On'),
            offText: window.Drupal.t('Off'),
            defaultOrange: "hsla(29, 87%, 50%, 1)",
            aaOrange: "hsl(29, 100%, 36%)",
        }
    },

    mounted() {
        this.checkInitialState()
    },

    methods: {
        handleChange() {
            if (this.highContrast) {
                localStorage.setItem('high-contrast', '1')
                document.body.classList.add('high-contrast');
                document.documentElement.style.setProperty('--color-secondary', this.aaOrange);
                return;
            }

            document.body.classList.remove('high-contrast')
            localStorage.removeItem('high-contrast')
            document.documentElement.style.setProperty('--color-secondary', this.defaultOrange);
        },

        checkInitialState() {
            if (lodash.isNil(localStorage.getItem('high-contrast'))) {
                return;
            }

            this.highContrast = true
            document.body.classList.add('high-contrast')
            document.documentElement.style.setProperty('--color-secondary', this.aaOrange);
        }
    }
}
</script>